import { useEffect, useState } from "react";
import server from "../lib/fetchRequests";
import { routeHandler } from "../lib/routeHandlers";
import { Model, Listener, Query, Id, List } from "../../lib/typeDeclarations";
const Server = new server();

export const useListRecords = (
  model: Model,
  listener: Listener,
  query: Query,
  refetchInterval?: number | undefined
) => {
  const [data, setData] = useState<List>({ page: 0, pages: 0, limit: 0, total: 0, data: [] });
  const [loading, setLoading] = useState(true);

  const URL = routeHandler(model);

  const queryString = ["?"];

  if (query) {
    for (const item of Object.keys(query)) {
      query[item] !== null && queryString.push(`${item}=${query[item]}&`);
    }
  }

  const fetch = async () => {
    if (listener.some((item) => item === undefined)) {
      setLoading(false);
      return;
    }

    const response = await Server.get(URL + queryString.join("").substring(0, queryString.join("").length - 1));
    if (response.status === 401 || response.status === 403) {
      return;
    }
    setLoading(false);
    setData(response.data);
  };

  useEffect(() => {
    setLoading(true);
    fetch();
  }, listener);

  // Polling effect - runs on mount and when intervalMs changes
  useEffect(() => {
    if (!refetchInterval) return;

    const interval = setInterval(fetch, refetchInterval);
    return () => clearInterval(interval);
  }, [refetchInterval, listener]);

  return { data, loading };
};

export const useFindById = (model: Model, listener: Listener, id: Id) => {
  const [data, setData] = useState<{ [key: string]: any }>({});
  const [loading, setLoading] = useState(true);
  const URL = routeHandler(model);

  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      const response = await Server.get(URL + "/" + id);
      if (response.status === 401 || response.status === 403) {
        return;
      }
      setLoading(false);
      setData(response.data);
    };
    id && fetch();
  }, listener);

  return { data, loading };
};
